import React, { useState, useContext } from "react"
import { SlSpeech } from "react-icons/sl"
import { Mutation } from "react-apollo"
import gql from "graphql-tag"
import AppContext from "../../shared/AppContext"
import FeedbackModalContainer from "./FeedbackModalContainer"

import "./feedback.scss"

const CREATE_UPDATE_FEEDBACK_MUTATION = gql`
  mutation CreateUpdateFeedback(
    $feedbackType: String!
    $feedbackTypeId: String!
    $question: String!
    $answer: String!
  ) {
    createUpdateFeedback(
      feedbackType: $feedbackType
      feedbackTypeId: $feedbackTypeId
      question: $question
      answer: $answer
    ) {
      success
      message
    }
  }
`

const FeedbackModal = (props) => {
  const { feedbackTypeId, feedbackType, title, children } = props

  const [isModalOpen, setIsModalOpen] = useState(false)
  const { trackEvent } = useContext(AppContext)

  const FeedbackModalButton = () => {
    return (
      <div className="feedback-modal-button">
        <button
          data-cy="feedback-modal-button"
          onClick={() => {
            setIsModalOpen(true)
            trackEvent(`Start Survey`, {
              section: feedbackType,
              title: title,
              "element id": feedbackTypeId,
            })
          }}
        >
          <SlSpeech />
          Share your opinion with us
        </button>
      </div>
    )
  }

  return (
    <>
      <FeedbackModalButton />
      {isModalOpen ? (
        <Mutation mutation={CREATE_UPDATE_FEEDBACK_MUTATION}>
          {(createUpdateFeedback) => {
            return (
              <FeedbackModalContainer
                setIsModalOpen={setIsModalOpen}
                feedbackTypeId={feedbackTypeId}
                feedbackType={feedbackType}
                createUpdateFeedback={createUpdateFeedback}
              >
                {children}
              </FeedbackModalContainer>
            )
          }}
        </Mutation>
      ) : null}
    </>
  )
}

export default FeedbackModal
